<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">SMS 충전</span>
            <span class="txt">메시지에 사용하는 금액을 충전하고 내역을 확인할 수 있습니다.</span>
        </div>

        <div class="com-search-content">
            <div class="line">
                <div class="com-calendar-wrap">
                    <single-calendar :start-date="startDate" @update="startDateUpdate"></single-calendar>
                    <span class="dash">~</span>
                    <single-calendar :end-date="endDate" @update="endDateUpdate"></single-calendar>
                </div>
                <select-form
                    :select-data="['기간선택', ...periodTypeList]"
                    :select-value="['', ...periodTypeValueList]"
                    :selected-value="period"
                    @update:set="(val) => (period = val)"
                ></select-form>
                <select-form
                    :select-data="statusList"
                    :select-value="statusList"
                    :selectedValue="selectedStatus"
                    @update:set="handleSelectedStatusChange"
                    @update:selected="selectedStatus"
                ></select-form>
                <button class="com-search-reset" @click="fetchPaymentHistory"></button>
                <!-- <div class="com-search-input">
                    <input v-model="searchStr" placeholder="" type="text" @keyup.enter="onEventSearch" />
                    <button class="search-btn" @click="onEventSearch">검색</button>
                </div> -->
            </div>
        </div>

        <div class="com-table-content com-msg-content">
            <div class="table-header com-btn-area">
                <div class="left-box">
                    <button class="com-btn excel" @click="getExcel">엑셀 다운로드</button>
                </div>
                <div class="right-box">
                    <span class="txt">
                        총
                        <span class="blue">{{ totalItems }}</span>
                        건
                    </span>
                    <button class="com-btn blue" @click="payBtn">SMS 충전</button>
                </div>
            </div>
            <table class="com-table">
                <colgroup>
                    <col style="width: 180px" />
                    <col style="width: 130px" />
                    <col style="width: 320px" />
                    <col style="width: 130px" />
                    <col style="width: 130px" />
                    <col style="width: 130px" />
                    <col />
                </colgroup>
                <thead>
                    <tr>
                        <th>
                            <button>결제일시</button>
                        </th>
                        <th>충전금액</th>
                        <th>결제금액</th>
                        <th>결제수단</th>
                        <th>잔여금액</th>
                        <th>상태</th>
                        <th>비고</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in resultCodeToStatus" :key="index">
                        <td>{{ item.AuthDate }}</td>
                        <td>{{ formatNumber(item.chargedpoint) + '원' }}</td>
                        <td>{{ formatNumber(item.amt) + '원' }}</td>
                        <td>{{ toKoreanCard(item.PayMethod) }}</td>
                        <td>{{ formatNumber(item.beforepoint) + '원' }}</td>
                        <td>{{ item.progress }}</td>
                        <td>{{ item.memo }}</td>
                    </tr>
                </tbody>
                <!-- <tbody>
                    <tr>
                        <td>2023-03-07 HH:MM:SS</td>
                        <td>500,000원</td>
                        <td>500,000원</td>
                        <td>[카드] 500,000원</td>
                        <td>580,000원</td>
                        <td>결제완료</td>
                        <td></td>
                    </tr>
                </tbody> -->
            </table>
            <div class="sort-bottom-area">
                <select-form
                    :select-data="[...sortTypeList]"
                    :select-value="[...sortTypeValueList]"
                    class="float-right"
                    @update:set="changeLimit"
                ></select-form>
            </div>
            <b-pagination
                v-model="pagingInfo.page"
                :per-page="pagingInfo.limit"
                :total-rows="pagingInfo.totalItems"
                align="center"
                aria-controls="my-table"
                first-class="first"
                last-class="last"
                next-class="next"
                prev-class="prev"
                @change="handlerPagenation($event)"
            ></b-pagination>
        </div>

        <!-- 이미지 미리보기 팝업 -->
        <div v-show="imagePop" class="layer-pop notice-pop">
            <div class="view-content">
                <div class="top-area">
                    <span class="title">미리보기</span>
                    <button class="close-btn" @click="imagePop = false"></button>
                </div>
                <div class="view-area">
                    <img :src="img" alt="" />
                </div>
                <div class="bottom-area">
                    <div class="week-check">
                        <button class="close" @click="imagePop = false">닫기</button>
                    </div>
                </div>
            </div>
        </div>
        <div v-show="smsChargePop" class="layer-pop square" :style="{ zIndex: 33 }">
            <div class="view-content w600">
                <button class="close" @click="smsChargePop = false">
                    <span class="blind">팝업 닫기</span>
                </button>
                <div class="scroll-area com-scroll-y">
                    <p class="pop-tit">SMS 금액 충전</p>
                    <div class="sms-charge-pop">
                        <div class="info-wrap">
                            최소 충전 금액은 10,000원입니다. (부가세 제외)
                            <br />
                            충전금액을 ‘직접 입력’으로 선택하셨을 경우, 금액은 만 원 단위로 숫자만 입력 가능합니다.
                        </div>
                        <table class="com-table">
                            <tbody>
                                <tr>
                                    <th>
                                        센터명
                                        <span class="require">*</span>
                                    </th>
                                    <td>
                                        <input type="text" :value="centerInfo.centerName" readonly />
                                    </td>
                                </tr>
                                <tr>
                                    <th>보유 금액</th>
                                    <td class="won-text">
                                        <input type="text" :value="formatNumber(remains.point)" readonly />
                                    </td>
                                </tr>
                                <!-- 충전 금액 선택 -->
                                <tr>
                                    <th>
                                        충전 금액
                                        <span class="require">*</span>
                                    </th>
                                    <td>
                                        <select-form
                                            :select-data="chargeAmountOptions.data"
                                            :select-value="chargeAmountOptions.value"
                                            :selectedValue="selectedChargeAmount"
                                            @update:set="handleSelectedTextChange"
                                            @update:selected="handleChargeAmountChange"
                                        ></select-form>
                                    </td>
                                </tr>

                                <tr v-if="selectedChargeAmount === '직접입력'">
                                    <th>
                                        충전 금액
                                        <span class="require">*</span>
                                    </th>
                                    <td class="won-text">
                                        <input
                                            v-model="customChargeAmount"
                                            type="text"
                                            placeholder="금액을 입력하세요 (만원 단위)"
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="table-info">
                            <strong>결제 진행 금액</strong>
                            <span class="amount">{{ formatNumber(finalChargeAmount) }}</span>
                            원 (부가세 포함)
                        </div>
                        <div class="com-check">
                            <input id="agreeCheckbox" name="agree" type="checkbox" v-model="isAgreed" />
                            <label for="agreeCheckbox">위 내용을 확인하였으며, 결제 진행에 동의합니다.</label>
                        </div>
                        <div class="bottom-btn">
                            <button class="com-btn" @click="smsChargePop = false">취소</button>
                            <button @click="nicepayStart()" class="com-btn blue">다음</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <iframe name="hiddenFrame" style="display: none"></iframe> -->
        <form name="payForm" method="post" :action="paymentActionUrl" class="nicePay">
            <table>
                <tr>
                    <th>PayMethod</th>
                    <!-- <td><input type="hidden" name="PayMethod" value="CARD,VBANK" /></td> -->
                    <td><input type="hidden" name="PayMethod" value="CARD" /></td>
                </tr>
                <tr>
                    <th>GoodsName</th>
                    <td><input type="hidden" name="GoodsName" value="SMS 충전" /></td>
                </tr>
                <tr>
                    <th>Amt</th>
                    <td>
                        <input type="hidden" name="Amt" v-model="finalChargeAmount" />
                    </td>
                    <!-- <td><input type="text" name="Amt" v-model=sampleAmt /></td> -->
                </tr>
                <tr>
                    <th>MID</th>
                    <td>
                        <input type="hidden" name="MID" v-model="MID" />
                    </td>
                </tr>
                <tr>
                    <th>Moid</th>
                    <td>
                        <input type="hidden" name="Moid" v-model="Moid" />
                    </td>
                </tr>
                <tr>
                    <th>BuyerName</th>
                    <td>
                        <input type="hidden" name="BuyerName" v-model="uName" />
                    </td>
                </tr>
                <tr>
                    <th>BuyerEmail</th>
                    <td>
                        <input type="hidden" name="BuyerEmail" v-model="staffEmail" />
                    </td>
                </tr>
                <tr>
                    <th>BuyerTel</th>
                    <td>
                        <input type="hidden" name="BuyerTel" value="" />
                    </td>
                </tr>
                <tr>
                    <th>ReturnURL [Mobile only]</th>
                    <td>
                        <input type="hidden" name="ReturnURL" value="" />
                    </td>
                </tr>
                <tr>
                    <th>Virtual Account Expiration Date(YYYYMMDD)</th>
                    <td>
                        <input type="hidden" name="VbankExpDate" value="" />
                    </td>
                </tr>

                <input type="hidden" name="NpLang" value="KO" />
                <!-- EN:English, CN:Chinese, KO:Korean -->
                <input type="hidden" name="GoodsCl" value="1" />
                <!-- products(1), contents(0)) -->
                <input type="hidden" name="TransType" value="0" />
                <!-- USE escrow false(0)/true(1) -->
                <input type="hidden" name="CharSet" value="utf-8" />
                <!-- Return CharSet -->
                <input type="hidden" name="ReqReserved" value="" />
                <!-- mall custom field -->
                <input type="hidden" name="ConnWithIframe" value="Y" />
                <!-- DO NOT CHANGE -->
                <input type="hidden" name="EdiDate" ref="ediDateInput" :value="ediDate" />
                <!-- YYYYMMDDHHMISS -->
                <!-- <input type="hidden" name="SignData" v-model="signData" /> -->
                <input type="hidden" name="SignData" ref="signDataInput" />
                <!-- signData -->
            </table>
            <a href="#" class="btn_blue" onClick="nicepayStart();">REQUEST</a>
        </form>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import { pagingInfo } from '@/assets/js/common';
import paymentApi from '@/assets/js/paymentApi';
import CryptoJS from 'crypto-js';
import moment from 'moment';
import XLSX from 'xlsx';
import EventBus from '../../../assets/js/eventBus';

export default {
    name: 'messageHistory',
    props: {},
    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
        nicepayClose() {
            alert('결제가 취소 되었습니다');
        },
        paymentActionUrl() {
            return process.env.VUE_APP_PAYMENT_API_URL + '/admin/api/payment/approvalRequest';
        },
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
        uName() {
            const { getters } = this.$store;
            return getters['auth/userName'];
        },
        staffEmail() {
            const { getters } = this.$store;
            return getters['auth/staffEmail'];
        },
        finalChargeAmount() {
            let amount = 0;
            // '직접입력' 선택 시 사용자가 입력한 금액을 사용
            if (this.selectedChargeAmount === '직접입력') {
                // 사용자 입력값이 문자열인지 확인하고, 문자열로 변환
                const inputAmount = String(this.customChargeAmount);
                amount = parseFloat(inputAmount.replace(/,/g, '')) || 0;
            } else {
                // 선택된 금액 옵션 사용
                const selectedAmount = String(this.selectedChargeAmount);
                amount = parseFloat(selectedAmount.replace(/,/g, '')) || 0;
            }
            const finalAmount = amount + amount * this.taxRate;
            return Math.round(finalAmount);
        },
        resultCodeToStatus() {
            return this.paymentHistory.map((item) => {
                let status;
                console.log(item);
                if (item.PayMethod == 'Admin') {
                    // 관리자 포인트인 경우
                    const adminDate = new Date(item.authdate).toLocaleString('ko-KR');

                    return {
                        ...item,
                        PayMethod: '관리자',
                        AuthDate: adminDate,
                        progress: '승인', // 관리자 포인트 충전으로 명시
                    };
                } else {
                    console.log(item.progress);
                    switch (item.progress) {
                        case 'rejected':
                            status = '거절';
                            break;
                        case 'cancel':
                            status = '취소';
                            break;
                        case 'inProgress':
                            status = '진행중';
                            break;
                        case 'approved':
                            status = '승인';
                            break;
                        default:
                            status = '';
                    }

                    // AuthDate를 Date 객체로 변환
                    // const date = new Date(
                    //     `20${item.authdate.slice(0, 2)}-${item.authdate.slice(2, 4)}-${item.authdate.slice(4, 6)}T${item.authdate.slice(6, 8)}:${item.authdate.slice(8, 10)}:${item.authdate.slice(10, 12)}`
                    // );

                    // // Date 객체를 한국 시간으로 변환
                    // const authDate = date.toLocaleString('ko-KR');

                    // AuthDate를 Date 객체로 직접 변환
                    const date = new Date(item.authdate);

                    // Date 객체를 한국 시간으로 변환
                    const authDate = date.toLocaleString('ko-KR', { timeZone: 'Asia/Seoul' });

                    return { ...item, AuthDate: authDate, progress: status };
                }
            });
        },
        selectData() {
            switch (this.selectedStatus) {
                case '승인':
                    return ['승인'];
                case '거절':
                    return ['거절'];
                case '진행중':
                    return ['진행중'];
                case '취소':
                    return ['취소'];
                default:
                    return ['처리상태', '승인', '거절', '진행중', '취소'];
            }
        },
        koreanCardValue() {
            return this.cardValue === 'CARD' ? '카드' : this.cardValue;
        },
    },

    watch: {
        period(newValue) {
            this.period = newValue;
            if (newValue === 'thisMonth') {
                this.startDate = moment().startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'prevMonth') {
                this.startDate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'today') {
                this.startDate = moment().format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'yesterday') {
                this.startDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
            } else if (newValue === 'lastWeek') {
                this.startDate = moment().subtract(7, 'days').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'threeMonth') {
                this.startDate = moment().subtract(3, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'sixMonth') {
                this.startDate = moment().subtract(6, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'year') {
                this.startDate = moment().subtract(12, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            }
            this.fetchPaymentHistory();
        },
        startDate(newValue) {
            this.startDate = newValue;
        },
        endDate(newValue) {
            this.endDate = newValue;
        },
        searchSmsType(newValue) {
            this.searchSmsType = newValue;
            this.fetchPaymentHistory();
        },
        sendOk(newValue) {
            this.sendOk = newValue;
            this.fetchPaymentHistory();
        },
        sender(newValue) {
            this.sender = newValue;
            this.fetchPaymentHistory();
        },
        statusList(newValue) {
            this.statusList = newValue;
            this.fetchPaymentHistory();
        },
        startDate(newStartDate, oldStartDate) {
            console.log(`startDate가 ${oldStartDate}에서 ${newStartDate}로 변경되었습니다.`);
        },
        endDate(newEndDate, oldEndDate) {
            console.log(`endDate가 ${oldEndDate}에서 ${newEndDate}로 변경되었습니다.`);
        },
        selectedStatus(newStatus) {
            console.log('selectedChargeAmount changed to:', newStatus);
            this.fetchPaymentHistory();
        },
    },
    data() {
        return {
            imagePop: false,
            centerId: '',
            startDate: this.initStartDate(),
            endDate: this.initEndDate(),
            periodTypeList: ['오늘', '어제', '최근 일주일', '이번 달', '지난 달', '3개월', '6개월', '12개월'],
            periodTypeValueList: [
                'today',
                'yesterday',
                'lastWeek',
                'thisMonth',
                'prevMonth',
                'threeMonth',
                'sixMonth',
                'year',
            ],
            sortTypeList: ['10줄보기', '20줄보기', '50줄보기', '100줄보기'],
            sortTypeValueList: [10, 20, 50, 100],
            // sortTypeList: [ ...this.$sortType ],
            // sortTypeValueList: [ ...this.$sortTypeValue],
            pagingInfo: { ...pagingInfo },
            searchStr: '',
            period: '',
            historyList: [],
            sendOk: '',
            sender: '',
            staffNameList: [],
            staffValList: [],
            img: '', // '/img/temp/popup_1.png',
            url: '',
            selectedChargeAmount: '', // 선택된 충전 금액
            customChargeAmount: '', // 사용자가 입력한 충전 금액
            chargeAmountOptions: {
                data: ['10,000원(최소결제금액)', '30,000원', '50,000원', '100,000원', '직접입력'],
                value: ['10,000원(최소결제금액)', '30,000원', '50,000원', '100,000원', '직접입력'],
                selectedChargeAmount: '',
            },
            taxRate: 0.1, // 부가세율
            isAgreed: false,
            ediDate: '',
            points: 0,
            Moid: '',
            MID: process.env.VUE_APP_NICE_PAY_MID,
            merchantKey: process.env.VUE_APP_NICE_PAY_KEY,
            signData: '',
            paymentMessage: null,
            selectedMonth: null,
            selectedDate: moment().format('YYYY-MM-DD'),
            smsChargePop: false,
            centerInfo: {},
            remains: {
                lms: 0,
                mms: 0,
                sms: 0,
            },
            centerId: '',
            paymentHistory: [],
            selectedStatus: '처리상태',
            statusList: ['처리상태', '모두', '승인', '거절', '진행중', '취소'],
            totalItems: 0,
        };
    },
    mounted() {
        this.centerId = this.cId; // 센터id
        this.init();
        this.fetchPaymentHistory();
    },
    created() {},
    methods: {
        // 초기화
        async init() {
            this.pagingInfo.page = 1;
            this.pagingInfo.limit = 10;
            this.fetchRemainInfo(); //센터, 포인트 정보
        },
        // 검색 종료일
        initEndDate() {
            const endDate = moment().format('YYYY-MM-DD');
            return endDate;
        },

        // 검색 시작일
        initStartDate() {
            const startDate = moment().subtract(1, 'months').format('YYYY-MM-DD');
            return startDate;
        },
        // 검색 시작일 변경 event
        startDateUpdate(val) {
            this.startDate = val;
            this.fetchPaymentHistory();
        },

        // 검색 종료일 변경 event
        endDateUpdate(val) {
            this.endDate = val;
            this.fetchPaymentHistory();
        },
        // 검색 조건 초기화
        resetSearchContent() {
            this.startDate = this.initStartDate();
            this.endDate = this.initEndDate();
            this.period = '';
            (this.searchSmsType = ''), (this.searchStr = '');
            this.fetchPaymentHistory();
            EventBus.$emit('event:init', 'init');
        },
        // 검색어 입력
        onEventSearch(e) {
            // if (this.searchStr.length > 0 && this.searchStr.length < 2) {
            //     return;
            // }
            if (this.searchStr.trim().length < 1) {
                alert('검색어를 입력해 주세요.');
                return;
            }
            this.fetchPaymentHistory();
        },
        // 페이징 Param 설정
        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },
        // 한 페이지에 표시되는 줄 수 변경
        changeLimit(val) {
            this.pagingInfo.limit = val;
            this.fetchPaymentHistory();
        },

        getExcel() {
            const dataWS = XLSX.utils.json_to_sheet(this.paymentHistory);
            const wb = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(wb, dataWS, 'paymentHistory');
            XLSX.writeFile(wb, 'paymentHistory.xlsx');
        },
        // 페이징 이벤트
        handlerPagenation(event) {
            this.pagingInfo.page = event;
            this.fetchPaymentHistory();
        },
        generateSignData() {
            const ediDate = moment().format('YYYYMMDDHHmmss');
            this.$refs.ediDateInput.value = ediDate;
            this.ediDate = ediDate;
            const dataString = ediDate + this.MID + this.finalChargeAmount + this.merchantKey;
            const hash = CryptoJS.SHA256(dataString);
            const hexHash = CryptoJS.enc.Hex.stringify(hash);

            // signData 값 업데이트
            this.signData = hexHash;

            // ref를 사용하여 SignData 입력 필드의 value를 직접 업데이트
            if (this.$refs.signDataInput) {
                this.$refs.signDataInput.value = hexHash;
            }
        },
        async payBtn() {
            this.smsChargePop = true;

            const centerIdAsNumber = Number(this.cId);
            let responseData = null;
            try {
                const response = await paymentApi.post('/admin/api/payment/createOrder', {
                    centerId: centerIdAsNumber,
                });
                console.log('결제 준비 응답:', response.data);
                responseData = response.data;
            } catch (error) {
                console.error('결제 준비 요청 실패:', error);
            }
            this.Moid = responseData;
        },
        async nicepayStart() {
            if (!this.isAgreed) {
                alert('약관에 동의해주세요.');
                return;
            }
            if (this.finalChargeAmount <= 10000) {
                alert('1만원 이상부터 결제 가능합니다');
                return;
            }
            this.generateSignData();
            document.payForm.target = 'hiddenFrame';
            goPay(document.payForm);
        },
        getMoid() {
            console.log('getMoid:', this.Moid);
            return this.Moid;
        },
        async fetchRemainInfo() {
            try {
                const { data } = await api.get(`/admin/api/center/${this.centerId}`);
                //const { data: countData } = await api.get(`/admin/api/center/${this.centerId}/message/sms/count`);
                const { data: pointData } = await paymentApi.get(`/admin/api/payment/point/${this.centerId}`);
                this.centerInfo = data;
                console.log('centerInfo', this.centerInfo);

                // 센터명과 "직접 입력"을 centerNames 배열에 추가
                this.centerNames = [this.centerInfo.centerName, '직접 입력'];
                // 선택된 센터명의 초기값 설정
                this.selectedCenterName = this.centerInfo.centerName;

                const { remains } = this;
                const points = pointData.point || 0; // 사용 가능한 포인트
                // 각 메시지 타입별 단가
                const smsPrice = 12;
                const lmsPrice = 35;
                const mmsPrice = 90;
                // 각 메시지 타입별 최대 보낼 수 있는 메시지 수 계산
                const maxSmsCount = Math.floor(points / smsPrice);
                const maxLmsCount = Math.floor(points / lmsPrice);
                const maxMmsCount = Math.floor(points / mmsPrice);

                // 계산된 값으로 remains 객체 업데이트
                this.remains.sms = maxSmsCount;
                this.remains.lms = maxLmsCount;
                this.remains.mms = maxMmsCount;
                this.remains.point = points; // 남은 포인트도 업데이트
            } catch (e) {}
        },
        handleSelectedTextChange(selectedText) {
            // 선택된 텍스트 값을 처리하는 로직
            console.log('선택된 텍스트:', selectedText);
        },
        handleChargeAmountChange(selectedText) {
            this.selectedChargeAmount = selectedText;
            console.log('선택된 금액:', this.selectedChargeAmount);
        },
        statusToApiFormat(status) {
            switch (status) {
                case '승인':
                    return 'approved';
                case '거절':
                    return 'rejected';
                case '진행중':
                    return 'inProgress';
                case '취소':
                    return 'cancel';
                case '모두':
                case '처리상태':
                default:
                    return null;
            }
        },
        async fetchPaymentHistory() {
            const progress = this.statusToApiFormat(this.selectedStatus);
            const response = await paymentApi.post(`/admin/api/payment/history/${this.centerId}`, {
                startDate: this.startDate,
                endDate: this.endDate,
                page: this.pagingInfo.page,
                skip: this.pagingInfo.limit,
                searchKeyword: this.searchStr,
                ...(progress && { progress }),
            });

            this.paymentHistory = response.data.list;
            this.totalItems = response.data.count;
            this.pagingInfo.totalItems = response.data.count;
            console.log('paymentHistory', this.paymentHistory);
        },
        //쉼표 찍기
        formatNumber(value) {
            return new Intl.NumberFormat().format(value);
        },
        toKoreanCard(value) {
            return value === 'CARD' ? '카드' : value;
        },

        handleSelectedStatusChange(selectedText) {
            this.selectedStatus = selectedText;
            console.log('선택된 금액:', this.selectedStatus);
        },
    },
};
</script>
<style lang="scss"></style>
